import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Other } from 'simplydo/interfaces';
import styled from 'styled-components';

type IIdeaBusinessProfileChip = {
  businessName: string,
  ideaBusinessProfile?: Other.IIdeaBusinessProfile,
  as?: ReactNode,
  style?: object,
  textStyle?: object,
  onClick?: (event) => void,
  colour?: string,
  precedingText?: string,
  className?: string,
  compact?: boolean,
  inverted?: boolean,
}

const StyledChip = styled.div<{ inverted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  ${({ inverted }) => inverted && `
    border-radius: 50px;
    padding: 3px 8px 3px 8px;
    background: #332c2c38;
  `}
`;


const IdeaBusinessProfileChip = ({
  businessName, ideaBusinessProfile, as, style = {}, onClick, precedingText, className, textStyle, compact, inverted,
}: IIdeaBusinessProfileChip) => {
  const size = compact ? 20 : 30;
  return (
  <StyledChip inverted={inverted} style={style} onClick={(e) => onClick && onClick(e)} className={className}>
    {ideaBusinessProfile?.profile?.imageUrl
      ? (
        <span
          // @ts-ignore
          as={as || Link}
          style={{
            backgroundImage: `url(${ideaBusinessProfile.profile.imageUrl})`, display: 'inline-block', verticalAlign: 'middle', width: size, height: size, minWidth: size, minHeight: size, lineHeight: 'inherit', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat',
          }}
        />
      ) : null
    }
    <span style={textStyle}>
      {' '}{precedingText}{businessName}
    </span>
  </StyledChip>
  );
};

export default IdeaBusinessProfileChip;
